// Meridian (design library 1.0): the library stylesheet first (reset, fonts, --ow-* tokens, component CSS), then the
// local glue on those tokens (src/ds/ds.css). Ark has no global stylesheet of its own any more.
import "@orbitalwatch/design/styles.css";
import "./ds/ds.css";

import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { SPAApp } from "./lib/infrastructure/app/SPAApp";
import { Startup } from "./lib/infrastructure/app/Startup";
import { applyTheme, readTheme } from "./modules/shell/theme";

// The stored theme (account menu) before anything paints.
applyTheme(readTheme());

Startup.Run(() => {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(
    <BrowserRouter>
      <SPAApp>
        <App />
      </SPAApp>
    </BrowserRouter>
  );
});
